import theme from '../../theme';

const UploadIcon = ({ color = theme.palette.text.secondary }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7494 9.63095V13.4405C14.7494 13.8446 14.589 14.2322 14.3032 14.518C14.0174 14.8037 13.6298 14.9643 13.2256 14.9643H2.55897C2.15483 14.9643 1.76735 14.8037 1.48158 14.518C1.19582 14.2322 1.03516 13.8446 1.03516 13.4405V2.77381C1.03516 2.36967 1.19582 1.98211 1.48158 1.69634C1.76735 1.41057 2.15483 1.25 2.55897 1.25H6.36849"
        stroke={color}
        stroke-width="1.71429"
        stroke-miterlimit="10"
      />
      <path d="M7.89258 8.10749L14.1783 1.82178" stroke={color} stroke-width="1.71429" stroke-miterlimit="10" />
      <path d="M14.9644 7.32136V1.03564H8.67871" stroke={color} stroke-width="1.71429" stroke-linejoin="round" />
    </svg>
  );
};

export default UploadIcon;
